export interface TrackingParam {
  allowed: string[];
  payload: string;
}

export const TrackingParams: TrackingParam[] = [
  { allowed: ["channelId", "c"], payload: "channelId" },
  { allowed: ["clickId", "ci"], payload: "clickId" },
  { allowed: ["exceptionId", "e"], payload: "exceptionId" },
  { allowed: ["partnerId", "partner_id", "pid"], payload: "partnerId" },
  { allowed: ["referrer"], payload: "referrer" },
  { allowed: ["utmSource", "utm_source"], payload: "utmSource" },
  { allowed: ["utmMedium", "utm_medium"], payload: "utmMedium" },
  { allowed: ["utmExpid", "utm_expid"], payload: "utmExpid" },
  { allowed: ["utmReferrer", "utm_referrer"], payload: "utmReferrer" },
  { allowed: ["utmCampaign", "utm_campaign"], payload: "utmCampaign" },
  { allowed: ["utmContent", "utm_content"], payload: "utmContent" },
  { allowed: ["utmTerm", "utm_term"], payload: "utmTerm" },
];
